import { render } from "./GlobalDialog.vue?vue&type=template&id=05a1ce70"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__